import { siteLinks } from '../../content/siteContent';
import { BeehiivSubscribeForm } from './BeehiivSubscribeForm';

export function NewsletterSignup() {
  return (
    <section className="newsletter" aria-labelledby="newsletter-title">
      <div>
        <p className="eyebrow">Body · Breath · Mind</p>
        <h2 id="newsletter-title">A steadier rhythm for everyday wellbeing.</h2>
        <p>Receive practical notes on Qigong, movement, nutrition, and the Five Phases.</p>
        <a className="text-link" href={siteLinks.newsletter}>Read the newsletter</a>
      </div>
      <div className="newsletter__signup">
        <img
          className="newsletter__logo"
          src="/images/five-phases-health-logo.png"
          alt="5 Phases Health"
        />
        <BeehiivSubscribeForm />
        <a className="newsletter__fallback" href={siteLinks.newsletterSubscribe}>
          Open the full subscription page
        </a>
      </div>
    </section>
  );
}
